import {GTS_FAILURE, GTS_PENDING, GTS_SUCCESS} from './constants'
import {getTemplateAudits as getTemplateAuditsAPI} from '../../../services/templates'

export async function getTemplateAudits(params = {}, dispatch) {
  dispatch({type: GTS_PENDING})
  try {
    let response = await getTemplateAuditsAPI(params)
    dispatch({type: GTS_SUCCESS, payload: response})
  } catch (e) {
    console.log(`Get Template Audits Failed`)
    dispatch({type: GTS_FAILURE, payload: e})
  }
}

export async function updateTemplateAuditList(list, dispatch) {
  try {
    dispatch({type: GTS_SUCCESS, payload: list})
  } catch (e) {
    console.log(`Get Template Audits Failed`)
    dispatch({type: GTS_FAILURE, payload: e})
  }
}
